// Store/store.js
import { configureStore } from '@reduxjs/toolkit';
import mileSpaceReducer from '../Reducers/mileSpaceSlice';
import documentDataReducer from '../Reducers/documentInfoSlice';

export const store = configureStore({
    reducer: {
        mileSpace: mileSpaceReducer,
        documentData: documentDataReducer,
    },
});